import React from "react";

const CourseSvgDefs: React.FC = () => (
  <svg
    width="0"
    height="0"
    style={{ position: "absolute" }}
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      <g id="blob-1" transform="translate(-100,-100)">
        <path d="M192.43,117.14c11.53-46.12-30-39.2-53-53s-17.5-33.22-57.65-36.89S14.78,47.91,8,82.55s.25,82.91,53,94.55S180.9,163.26,192.43,117.14Z" />
        <path d="M149.36,21.44c-6.46,4.67-18.7,21.13-8.53,30.51s27.73,6.23,35.8-8.82c7.22-13.44-2.11-20.87-8.75-23.83S153.07,18.82,149.36,21.44Z" />
      </g>

      <g id="blob-2" transform="translate(100,-100) scale(-1,1)">
        <path d="M192.43,117.14c11.53-46.12-30-39.2-53-53s-17.5-33.22-57.65-36.89S14.78,47.91,8,82.55s.25,82.91,53,94.55S180.9,163.26,192.43,117.14Z" />
        <path d="M149.36,21.44c-6.46,4.67-18.7,21.13-8.53,30.51s27.73,6.23,35.8-8.82c7.22-13.44-2.11-20.87-8.75-23.83S153.07,18.82,149.36,21.44Z" />
      </g>

      <symbol id="ic-target" viewBox="0 0 24 24">
        <circle
          cx="12"
          cy="12"
          r="9"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        />
        <circle
          cx="12"
          cy="12"
          r="5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        />
        <circle cx="12" cy="12" r="1.5" fill="currentColor" />
      </symbol>

      <symbol id="ic-brain" viewBox="0 0 24 24">
        <path
          d="M9 4a3 3 0 0 0-3 3v1a3 3 0 0 0-2 5.83V15a3 3 0 0 0 3 3 3 3 0 0 0 6 0V7a3 3 0 0 0-4-3z M15 4a3 3 0 0 1 3 3v1a3 3 0 0 1 2 5.83V15a3 3 0 0 1-3 3"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </symbol>

      <symbol id="ic-spark" viewBox="0 0 24 24">
        <path
          d="M12 3l2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5z"
          fill="currentColor"
        />
      </symbol>

      <symbol id="ic-check" viewBox="0 0 24 24">
        <path
          d="M5 13l4 4L19 7"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>

      <symbol id="ic-cross" viewBox="0 0 24 24">
        <path
          d="M6 6l12 12M18 6L6 18"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
      </symbol>

      <symbol id="ic-shield" viewBox="0 0 24 24">
        <path
          d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M9 12l2 2 4-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>

      <symbol id="ic-clock" viewBox="0 0 24 24">
        <circle
          cx="12"
          cy="12"
          r="9"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M12 7v5l3 2"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </symbol>

      <symbol id="ic-li" viewBox="0 0 24 24">
        <path
          d="M4 4h4v16H4zM6 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM10 8h4v2c.7-1.4 2.4-2.4 4.5-2.4 4 0 4.5 2.6 4.5 6V20h-4v-5.4c0-1.7-.6-2.6-2-2.6s-2 1-2 2.6V20h-4z"
          fill="currentColor"
        />
      </symbol>

      <symbol id="ic-twit" viewBox="0 0 24 24">
        <path
          d="M3 3h4l5 7 5-7h3l-7 9 8 9h-4l-6-8-6 8H3l8-10z"
          fill="currentColor"
        />
      </symbol>

      <symbol id="ic-link" viewBox="0 0 24 24">
        <path
          d="M9 15l6-6M10 7l3-3a4 4 0 0 1 6 6l-3 3M14 17l-3 3a4 4 0 0 1-6-6l3-3"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </symbol>

      <symbol id="ic-gift" viewBox="0 0 24 24">
        <path
          d="M3 11h18v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z M2 7h20v4H2z M12 7v14 M9 7s-3 0-3-2.5S9 2 9 4.5 12 7 12 7 M15 7s3 0 3-2.5S15 2 15 4.5 12 7 12 7"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </symbol>
    </defs>
  </svg>
);

export default CourseSvgDefs;
